module.exports = __webpack_public_path__ + "static/media/01-10.63380e3e.mp3";